module.exports = __webpack_public_path__ + "static/media/crees1.7a719bb1.JPG";